import React from 'react';
import { patterns, patternNames } from './patterns';

interface PaithaniPatternProps {
  pattern?: keyof typeof patterns;
  color?: string;
  opacity?: number;
  className?: string;
}

const PaithaniPattern: React.FC<PaithaniPatternProps> = ({
  pattern = 'peacockFeather',
  color = 'var(--color-plum)',
  opacity = 0.15,
  className = ''
}) => {
  const patternSvg = patterns[pattern];

  return (
    <svg
      className={className}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        opacity,
        color
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs dangerouslySetInnerHTML={{ __html: patternSvg }} />
      <rect width="100%" height="100%" fill={`url(#${pattern})`} />
    </svg>
  );
};

export default PaithaniPattern;
